import type { HigherPeriod, Period } from '@/entities/types';

type PeriodStatuses = Record<HigherPeriod, { isPlanned: boolean; isSeen: boolean }>;

export function determineDefaultPeriod(statuses: PeriodStatuses): Period {
  const hierarchy: HigherPeriod[] = ['year', 'quarter', 'week'];

  for (const period of hierarchy) {
    if (!statuses[period].isPlanned && !statuses[period].isSeen) {
      return period;
    }
  }

  return 'day';
}
